import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f1e0325e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "manifold m-token-media" }

import { inject } from 'vue';
import LazyIframe from '@/components/LazyIframe.vue';
import LazyImage from '@/components/LazyImage.vue';
import LazyModel from '@/components/LazyModel.vue';
import LazyMusic from '@/components/LazyMusic.vue';
import LazyVideo from '@/components/LazyVideo.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'TokenMedia',
  setup(__props) {

const imageUrl: string = inject('image', '');
const animationUrl: string = inject('media', '');
const mediaIsVideo: boolean = inject('mediaIsVideo', false);
const mediaIsAudio: boolean = inject('mediaIsAudio', false);
const mediaIsModel: boolean = inject('mediaIsModel', false);
const mediaIsHtml: boolean = inject('mediaIsHtml', false);
// const mediaIsOther: string = inject('mediaIsOther', false);
const mediaAudioType: string = inject('mediaAudioType', '');

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(imageUrl) && !_unref(mediaIsVideo) && !_unref(mediaIsAudio) && !_unref(mediaIsModel) && !_unref(mediaIsHtml))
      ? (_openBlock(), _createBlock(LazyImage, {
          key: 0,
          src: _unref(imageUrl),
          class: _normalizeClass({ hide: _unref(mediaIsVideo) })
        }, null, 8, ["src", "class"]))
      : (_unref(animationUrl) && _unref(mediaIsVideo))
        ? _withDirectives((_openBlock(), _createBlock(LazyVideo, {
            key: 1,
            src: _unref(animationUrl),
            poster: _unref(imageUrl)
          }, null, 8, ["src", "poster"])), [
            [_vShow, _unref(mediaIsVideo)]
          ])
        : (_unref(animationUrl) && _unref(mediaIsAudio))
          ? _withDirectives((_openBlock(), _createBlock(LazyMusic, {
              key: 2,
              "image-src": _unref(imageUrl),
              "audio-type": _unref(mediaAudioType),
              "audio-src": _unref(animationUrl)
            }, null, 8, ["image-src", "audio-type", "audio-src"])), [
              [_vShow, _unref(mediaIsAudio)]
            ])
          : (_unref(animationUrl) && _unref(mediaIsModel))
            ? _withDirectives((_openBlock(), _createBlock(LazyModel, {
                key: 3,
                src: _unref(animationUrl)
              }, null, 8, ["src"])), [
                [_vShow, _unref(mediaIsModel)]
              ])
            : (_unref(animationUrl) && _unref(mediaIsHtml))
              ? _withDirectives((_openBlock(), _createBlock(LazyIframe, {
                  key: 4,
                  src: _unref(animationUrl)
                }, null, 8, ["src"])), [
                  [_vShow, _unref(mediaIsHtml)]
                ])
              : _createCommentVNode("", true)
  ]))
}
}

})